const validEmail = /^([a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+)@([a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*)$/

const privateRelayRegex = /[^@]+@privaterelay.+/i

export function validMailCheck(email: string): boolean {
    if(email) {
        const mat = email.match(validEmail);
        if(mat && mat.length > 2) {
            return !mat[2].match(privateRelayRegex);
        }
        else return false;
    }
    else return false;
    
}

export function validNameCheck(first_name: string, last_name: string): boolean {

    return nonNullNonEmptyName(first_name) && nonNullNonEmptyName(last_name);

}

function nonNullNonEmptyName(n: string): boolean {
    if(n) {
        const t = n.trim();
        return t != "" && t.length >= 1;
    }
    else return false; 
}